import { render, staticRenderFns } from "./AppointmentRequest.vue?vue&type=template&id=57e1bbcb&scoped=true&"
import script from "./AppointmentRequest.vue?vue&type=script&lang=ts&"
export * from "./AppointmentRequest.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentRequest.vue?vue&type=style&index=0&id=57e1bbcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e1bbcb",
  null
  
)

export default component.exports